import { useMemo } from 'react';
import { isNotNullish } from '@chainflip/utils/guard';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import { useStateChainAccount } from './useStateChainAccount';

const useOperatorAccount = (idSs58?: string) => {
  const { selectedAccount } = usePolkadot();
  const { accountInfo, isLoading: scAccountLoading } = useStateChainAccount();

  const data = useMemo(() => {
    const isCurrentAccount =
      isNotNullish(selectedAccount) &&
      accountInfo?.role === 'operator' &&
      (idSs58 === selectedAccount.idSs58 || idSs58 === undefined);

    if (!isCurrentAccount) return undefined;

    return {
      isLoading: scAccountLoading,
      delegationFeePips: accountInfo.upcoming_delegation.delegation_fee_bps,
      openDelegationEnabled: accountInfo.upcoming_delegation.delegation_acceptance === 'Allow',
      exceptionList: accountInfo.allowed.concat(accountInfo.blocked),
      delegators: new Map(
        Object.entries(accountInfo.upcoming_delegation.delegators) as [`cF${string}`, bigint][],
      ),
      id: selectedAccount.idSs58,
      validators: new Map(
        Object.entries(accountInfo.upcoming_delegation.validators) as [`cF${string}`, bigint][],
      ),
      alias: accountInfo.vanity_name,
    };
  }, [idSs58, accountInfo, selectedAccount, scAccountLoading]);

  return data;
};

export default useOperatorAccount;
